module.exports = __webpack_public_path__ + "media/images/category/dummy/accessory02-3f4ac3ce03869bde1a41095bf086dfde.jpg";